var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.$style.headerContainer
  }, [_vm.canGoBack ? _c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "data-period-back-arrow": "",
      "name": "Arrow",
      "icon-color": "gray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.goBack.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm.orderedUsers.length && _vm.officeYTD ? _c('div', {
    staticClass: "mx-auto position-relative width-fit-content"
  }, [_c('h1', {
    staticClass: "color-primary-blue text-center mb-3 px-1"
  }, [_vm._v(_vm._s(_vm.getYTDLabel) + " Office: " + _vm._s(_vm.officeYTD) + " "), _c('Tooltip', {
    attrs: {
      "target": "ytd-production-for-office",
      "placement": "bottom",
      "icon-absolute-position": false
    }
  }, [_c('span', {
    staticClass: "color-darkest-gray text-align-center overline-text font-weight-bold"
  }, [_vm._v("Production data is updated monthly when the Motto leaderboard is published.")])])], 1)]) : _vm._e(), _vm.canGoForward ? _c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.forwardButton,
    attrs: {
      "data-period-forward-arrow": "",
      "name": "Arrow",
      "icon-color": "gray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.goForward.apply(null, arguments);
      }
    }
  }) : _vm._e()], 1), _c('div', {
    class: _vm.$style.graphContainer
  }, [!_vm.orderedUsers.length || _vm.showPlaceholderUsers ? _c('div', {
    class: _vm.$style.noUsersContainer
  }, [_c('p', {
    staticClass: "button-text color-dark-gray"
  }, [_vm._v("Phase 2 LO production will be shown here.")])]) : _vm._e(), _c('Bar', {
    class: _vm.$style.barGraphContainer,
    attrs: {
      "chart-options": _vm.chartOptions,
      "plugins": _vm.chartPlugins,
      "chart-data": _vm.chartData
    }
  }), _c('div', {
    class: _vm.$style.profilePicturesContainer,
    style: {
      minHeight: "".concat(_vm.barWidth, "px")
    }
  }, _vm._l(_vm.orderedUsers, function (user, i) {
    return _c('div', {
      key: user.id
    }, [_c('ProfilePicture', {
      class: _vm.$style.profilePicture,
      style: {
        height: "".concat(_vm.barWidth, "px"),
        width: "".concat(_vm.barWidth, "px"),
        left: "".concat(_vm.allBarPositions[i] - _vm.barWidth / 2, "px")
      },
      attrs: {
        "id": user.id,
        "src": user.photoUrl,
        "data-profile-picture-user-id": user.id
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$emit('click-user-picture', user);
        }
      }
    }), !_vm.showPlaceholderUsers ? _c('b-tooltip', {
      attrs: {
        "target": "".concat(user.id),
        "placement": "bottom",
        "no-fade": "",
        "custom-class": "tooltipGray light-transparent"
      }
    }, [_c('p', {
      staticClass: "color-darkest-gray overline-text font-weight-bold"
    }, [_vm._v(_vm._s(user.name))])]) : _vm._e()], 1);
  }), 0)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }